import { render, staticRenderFns } from "./details-sidecard.vue?vue&type=template&id=3603ec6d"
import script from "./details-sidecard.vue?vue&type=script&lang=js"
export * from "./details-sidecard.vue?vue&type=script&lang=js"
import style0 from "./details-sidecard.vue?vue&type=style&index=0&id=3603ec6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports